import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            As an English major and versatile freelancer, I bring expertise in digital marketing, visual editing, storytelling, and business management. I'm fluent in English, Arabic, and French, adaptable to diverse environments, and passionate about entrepreneurship. I've launched my own graphic design service and am developing Fahemni, an education-focused project.          </p>

          <p className="text-justify">
            With hands-on experience in sustainability, team building, and brand identity, I'm committed to driving impactful results. Let’s connect to explore how I can support your brand’s growth and make it memorable!
          </p>
          /* <p style={{ color: "rgb(155 126 172)" }}>
            "Be Iconic Habibi!"{" "}
          </p>
          <footer className="blockquote-footer">Raouf Chatti</footer> */
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
